import { unstable_trace as trace } from 'scheduler/tracing';

function createScriptElement(id) {
    let ele = document.createElement("script");
    ele.id = id;
    ele.type = "text/javascript";

    return ele;
}

function addUtagData(UtagDataJS) {
    //add utag_data
    if (!document.getElementById('utag-data-js')) {
        let utagDataEl = createScriptElement('utag-data-js');
        utagDataEl.appendChild(document.createTextNode(`var utag_data = ${UtagDataJS};`));

        document.getElementById('tealium-registration').insertAdjacentElement('beforebegin', utagDataEl);
    }
}

function addUtagManager(UtagTagManagerJS) {
    //add utag manager
    if (!document.getElementById('utag-manager-js')) {
        let utagManagerEl = createScriptElement('utag-manager-js');
        utagManagerEl.appendChild(document.createTextNode(UtagTagManagerJS));
        utagManagerEl.appendChild(document.createTextNode('loadTealiumTagFn();'));

        document.getElementById('tealium-registration').insertAdjacentElement('afterend', utagManagerEl);
    }
}

export default function executeTealium(tealiumData) {
    const { UtagDataJS, UtagTagManagerJS } = tealiumData;

    if (process.env.REACT_APP_DISABLE_TEALIUM === 'true')
        return;

    //console.log('[Execute Tealium]');

    trace('Executing Tealium Script Loading', performance.now(), () => {
        addUtagData(UtagDataJS);
        addUtagManager(UtagTagManagerJS);
    });
    //console.log('Executing Tealium Script Loading');
}